<template>
	<v-app id="app">
		<app-alerts/>
		<router-view/>
	</v-app>
</template>

<script>

    import AppAlerts from './components/app/AppAlerts';
export default {
	name: 'App',

    components: {
        AppAlerts
    },
	data: () => ({
	}),
};
</script>

<style>
</style>
